<template>
  <common-template>
      <div class="list">
        <ul class="breadcrumbs">
          <li class="breadcrumbs__link">
            <a href="#" @click="mixinTransition('/product/index.html')">
              {{$t('製品情報一覧')}}
            </a>
          </li>
          <li>
            {{ $t(pageTitle) }}
          </li>
        </ul>
        <h1 class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>
        <div class="inner d-flex justify-content-between mt-4 mb-4">
          <!-- <button
            type="button"
            class="btn btn-danger create-btn"
          >
            {{ $t('戻る') }}
          </button> -->
          <span></span>
          <button
            type="button"
            class="btn btn-light create-btn"
            @click="revisionModal(product.id)"
          >
            {{ $t('複製して改訂') }}
          </button>
        </div>
        <div class="inner">
        <h2 class="fz-20 d-flex border-bottom mt-0">{{ $t('製品情報') }}</h2>
          <div class="table-list mb-5 mt-4">
            <div class="d-flex justify-content-between">
              <p v-if="product.type === 'ownbrand'" class="mb-0">{{ $t('内製品') }}</p>
              <p v-else-if="product.type === 'purchase'" class="mb-0">{{ $t('仕入品') }}</p>
              <p v-else-if="product.type === 'material'" class="mb-0">{{ $t('材料') }}</p>
              <p v-else-if="product.type === 'progress'" class="mb-0">{{ $t('仕掛品') }}</p>
              <p class="mb-0">{{$t('登録日')}}&nbsp;{{ product.registerDate | mixinDateFormatChange }}</p>
            </div>
            <div class="content detail-content">
              <table class="table table-bordered">
                <tbody class="tbody">
                  <tr>
                      <th class="table-active text-left" width='200'>{{ $t('品番') }}</th>
                      <td class="text-left">
                        <template v-if="product.code">
                          {{ product.code }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <th class="table-active text-left" width='200'>{{ $t('改訂') }}</th>
                      <td class="" style="padding:0;">
                        <div class="text-left d-flex justify-content-between align-items-center" style="border:1px solid #dee2e6;padding:5px; vertical-align:bottom;margin-bottom: -1px;">
                        <template v-if="product.version">
                          {{ product.version }}
                        </template>
                        <template v-else>
                          -
                        </template>
                        &nbsp;
                        <button
                          type="button"
                          class="btn btn-light create-btn"
                          @click="productTransition(product.code)"
                        >
                          {{ $t('改訂履歴') }}
                        </button>
                        </div>
                      </td>
                      <th class="table-active text-left" width='200'>{{ $t('品名') }}</th>
                      <td class="text-left">
                        <template v-if="product.name">
                          {{ product.name }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>

                    </tr>
                    <tr>
                      <th class="table-active text-left">{{ $t('図番') }}</th>
                      <td class="text-left">
                        <template v-if="product.figureNo">
                          {{ product.figureNo }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <th class="table-active text-left">{{ $t('単位') }}</th>
                      <td class="text-left">
                        <template v-if="product.outputLevel">
                          {{ product.outputLevel }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <th class="table-active text-left">{{ $t('RoHS指令対応') }}</th>
                      <td class="text-left">
                        <template v-if="product.isRoHS">
                          {{ $t('対応') }}
                        </template>
                        <template v-else>
                          {{ $t('非対応') }}
                        </template>
                      </td>

                    </tr>
                    <tr>
                      <template v-if="product.type === 'material' || product.type === 'supplier'">
                          <th class="table-active text-left">{{ $t('メーカー') }}</th>
                          <td class="text-left">
                            <template v-if="product.supplier">
                              {{ product.supplier }}
                            </template>
                            <template v-else>
                              -
                            </template>
                          </td>
                      </template>
                      <template v-if="product.type === 'material'">
                        <th class="table-active text-left">{{ $t('基準手配リードタイム') }}</th>
                        <td class="text-left">
                          <template v-if="product.materialLeadTime">
                            {{ product.materialLeadTime }}&nbsp;&nbsp;{{ $t('日') }}
                          </template>
                          <template v-else>
                            -&nbsp;&nbsp;{{ $t('日') }}
                          </template>
                        </td>
                      </template>
                    </tr>
                    <tr>
                      <th class="table-active text-left">{{ $t('自由記述項目1') }}</th>
                      <td class="text-left">
                        <template v-if="product.freeText1">
                          {{ product.freeText1 }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <th class="table-active text-left">{{ $t('自由記述項目2') }}</th>
                      <td class="text-left">
                        <template v-if="product.freeText2">
                          {{ product.freeText2 }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <th class="table-active text-left">{{ $t('自由記述項目3') }}</th>
                      <td class="text-left">
                        <template v-if="product.freeText3">
                          {{ product.freeText3 }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th class="table-active text-left">{{ $t('自由記述項目4') }}</th>
                      <td class="text-left">
                        <template v-if="product.freeText4">
                          {{ product.freeText4 }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <th class="table-active text-left">{{ $t('自由記述項目5') }}</th>
                      <td class="text-left">
                        <template v-if="product.freeText5">
                          {{ product.freeText5 }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <th class="table-active text-left">{{ $t('自由記述項目6') }}</th>
                      <td class="text-left">
                        <template v-if="product.freeText6">
                          {{ product.freeText6 }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th class="table-active text-left">{{ $t('自由記述項目7') }}</th>
                      <td class="text-left" colspan="99">
                        <template v-if="product.freeText7">
                          {{ product.freeText7 }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th class="table-active text-left">{{ $t('自由記述項目8') }}</th>
                      <td class="text-left" colspan="99">
                        <template v-if="product.freeText8">
                          {{ product.freeText8 }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th class="table-active text-left">{{ $t('自由記述項目9') }}</th>
                      <td class="text-left" colspan="99">
                        <template v-if="product.freeText9">
                          {{ product.freeText9 }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <template v-if="product.type === 'purchase'">
                        <th class="table-active text-left">{{ $t('メーカー') }}</th>
                        <td class="text-left">
                          <template v-if="product.supplier">
                            {{ product.supplier }}
                          </template>
                          <template v-else>
                            -
                          </template>
                        </td>
                      </template>
                      <th class="table-active text-left">{{ $t('備考') }}</th>
                      <td class="text-left" colspan="99">
                        <template v-if="product.note">
                          {{ product.note }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>

                    </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-between mt-3 mb-5">
              <button
                type="button"
                class="btn btn-light create-btn"
                @click="productModal()"
              >
                {{ $t('編集') }}
              </button>
            </div>
          </div>
        </div>
        <accordion-drawing
        :files="files"
        :productId="id"
        @init="getfiles()"
        ref="file"
        ></accordion-drawing>
        <product-shape-drawing
        :productShape="product"
        @registered="init()"
        @modalClose="init()"
        ></product-shape-drawing>
        <material-shape-drawing
        v-if="product.type !== 'purchase' && product.type !== 'material'"
        :material="material"
        :productId="id"
        @registered="init()"
        @modalClose="init()"
        ></material-shape-drawing>
        <base-process-drawing
        v-show="product.type !== 'purchase' && product.type !== 'material'"
        :baseProcesses="baseProcesses"
        :processes="processes"
        :processKinds="processKinds"
        :structures="structures"
        :users="masters.users"
        :productId="id"
        :contacts="masters['ordering/contacts']"
        :isArrangeMaterial="isArrangeMaterial"
        @addTotalCost="addTotalCost($event)"
        @registered="init()"
        @modalClose="init()"
        ></base-process-drawing>
        <component-parts-drawing
        v-if="product.type !== 'purchase' && product.type !== 'material'"
        :productId="id"
        :structures="structures"
        :processes="baseProcesses"
        :processKinds="processKinds"
        @registered="init()"
        @modalClose="init()"
        ></component-parts-drawing>
        <inventory-info-drawing
        :productId="id"
        :inventories="inventories"
        :inventoryKinds="masters.inventoryKinds"
        :spaces="masters.spaces"
        @registered="init()"
        @modalClose="init()"
        ></inventory-info-drawing>
        <cost-info-drawing
        :product="product"
        :totalCost="totalCost"
        @registered="init()"
        @modalClose="init()"
        ></cost-info-drawing>
        <partner-drawing
        v-if="product.type !== 'material'"
        :productId="id"
        :histories="histories"
        :productPartners="partners"
        :type="type"
        @initPartner="init()"
        @partnerAddModalOpen="partnerAddModalOpen($event)"
        @partnerFixModalOpen="partnerFixModalOpen($event)"
        ></partner-drawing>
        <material-supplier-drawing
        v-show="product.type === 'material' || product.type === 'ownbrand' && material.id"
        :productId="(product.type === 'material') ? id : material.id"
        :materialPartners="(product.type === 'material') ? partners : material.partners"
        :histories="(product.type === 'material') ? histories : material.prices"
        type="material"
        @registered="init()"
        @modalClose="init()"
        @init="init()"
        @partnerAddModalOpen="materialPartnerAddModalOpen($event)"
        @partnerFixModalOpen="materialPartnerFixModalOpen($event)"
        ></material-supplier-drawing>
        <product-modal
        ref="product"
        @registered="init()"
        ></product-modal>
        <partner-add-modal
        ref="partnerAdd"
        :productType="type"
        @modalClose="init()"
        @registered="init()"
        ></partner-add-modal>
        <partner-fix-modal
        ref="partnerFix"
        :productType="type"
        @modalClose="init()"
        @registered="init()"
        ></partner-fix-modal>
        <revision-modal ref="revision"></revision-modal>
      </div>
  </common-template>
</template>

<script>
import { mapGetters } from 'vuex'
import accordionDrawing from './accordionDrawing'
import baseProcessDrawing from './baseProcessDrawing'
import componentPartsDrawing from './componentPartsDrawing'
import costInfoDrawing from './costInfoDrawing'
import inventoryInfoDrawing from './inventoryInfoDrawing'
import materialShapeDrawing from './materialShapeDrawing'
import materialSupplierDrawing from './materialSupplierDrawing'
import partnerAddModal from './partnerAddModal'
import partnerDrawing from './partnerDrawing'
import partnerFixModal from './partnerFixModal'
import productModal from './productModal'
import productShapeDrawing from './productShapeDrawing'
import revisionModal from './revisionModal'

export default {
  data() {
    return {
      id: 0,
      type: '',
      totalCost: 0,
      product: {},
      files: [],
      masters: {
        users: [],
      },
      baseProcesses: [],
      inventories: [],
      partners: [],
      histories: [],
      material: {},
      structures: {},
      processes: [],
      processKinds: [],
      pageTitle: '製品詳細',
    }
  },
  components: {
    accordionDrawing,
    productShapeDrawing,
    materialShapeDrawing,
    baseProcessDrawing,
    componentPartsDrawing,
    inventoryInfoDrawing,
    costInfoDrawing,
    partnerDrawing,
    materialSupplierDrawing,
    partnerAddModal,
    partnerFixModal,
    productModal,
    revisionModal,
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    await this.$store.dispatch('auth/user')
    await this.getDetailProduct()
    await this.getMasters()
    this.getProcesses()
    this.getProcessKinds()
  },
  methods: {
    async getDetailProduct() {
      // パラメータがあれば、Formにデータを入れる
      const url = location.search
      const searchParams = new URLSearchParams(url)
      if (searchParams.get('id')) {
        this.id = Number(searchParams.get('id'))
      } else {
        window.location.href = process.env.NODE_ENV !== 'development' ? '/base/product/index.html' : '/product/index.html'
        return
      }
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/product`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: { id: this.id },
          }
        )
        if (Object.keys(res.data).length === 0) return
        this.product = res.data
        this.type = this.product.type
        this.inventories = this.product.inventories
        this.material = this.product.material
        if (!this.material) this.material = { id: 0}
        this.partners = this.product.partners
        this.partnerPrices = this.product.partnerPrices
        this.histories = this.product.prices
        this.structures = this.product.structures
        this.baseProcesses = this.product.processes
        await this.getfiles()
      } catch (err) {
        this.$toasted.show(`${this.$t('データ取得エラーメッセージ')}`)
      }
    },
    // mastersを取得
    async getMasters() {
      try {
        await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/masters`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        ).then(res => {
          this.masters = res.data
        })
      } catch (error) {
        this.$toasted.show(`${this.$t('データ取得エラーメッセージ')}`)
      }
    },
    // 工程を取得
    async getProcesses() {
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/processes`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: {
              limit: 600,
            },
          }
        )
        this.processes = res.data
      } catch (error) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    // 工程区分を取得
    async getProcessKinds() {
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/process/kinds`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        this.processKinds = res.data
      } catch (error) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    // 図面の画像などを取得
    async getfiles() {
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/product/files`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: { product_id: this.id },
          }
        )
        await this.replaceFilePath(res.data)
        await this.$refs.file.sliderClear()
      } catch (err) {
        this.$toasted.show(`${this.$t('データ取得エラーメッセージ')}`)
      }
    },
    // 図面の画像path置き換え
    async replaceFilePath(files) {
      let imagekeys = []
      imagekeys = files.map(item => {
        return item.path
      })
      try {
        const res = await this.$axios.post(
          `${this.$appConfig.CommonApiUrl}/s3/productUrls`,
          {'targets': [...imagekeys], 'productId': this.id},
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        const target = res.data
        this.files = this.mixin_deepcopy(files)
          .filter(item => target[item.path])
          .map(file => {
            if (target[file.path]) {
              const res = {}
              if (target[file.path].thumbnail) {
                res.id = file.id
                res.title = file.title
                res.path = target[file.path].thumbnail
                res.download = target[file.path].download
              } else {
                res.id = file.id
                res.title = file.title
                res.path = target[file.path]
                res.download = target[file.path]
              }
              return res
            }
          })
      } catch (err) {
        this.$toasted.show(`${this.$t('データ取得エラーメッセージ')}`)
      }
    },
    // 全データを初期化
    async init() {
      await this.getDetailProduct()
      await this.getMasters()
    },
    // 取引先の登録モーダルを開く
    partnerAddModalOpen(type) {
      this.$refs.partnerAdd.modalOpen(this.id, type)
    },
    // 取引先の修正モーダルを開く
    partnerFixModalOpen(obj) {
      this.$refs.partnerFix.modalOpen(obj.item, obj.type)
    },
    // 取引先の登録モーダルを開く
    materialPartnerAddModalOpen(type) {
      const id = this.type === 'material' ? this.id : this.material.id
      this.$refs.partnerAdd.modalOpen(id, type)
    },
    // 取引先の修正モーダルを開く
    materialPartnerFixModalOpen(obj) {
      this.$refs.partnerFix.modalOpen(obj.item, obj.type)
    },
    // 製品情報のモーダルを開く
    productModal() {
      this.$refs.product.modalOpen(this.product)
    },
    // 改訂のモーダルを開く
    revisionModal(id) {
      this.$refs.revision.modalOpen(id)
    },
    // 製品一覧に遷移する
    productTransition(code) {
      this.mixinTransition(`/product/index.html?code=${code}`)
    },
    // 品番だけを当該品にして登録画面に遷移
    createModal() {
      window.location.href = process.env.NODE_ENV !== 'development' ? `/base/product/create.html?code=${this.product.code}` : `/product/create.html?code=${this.product.code}`
    },
    async deleteAlert(item, state = 0) {
      const confirm = await this.$swal({
        text: `${item.name}}` + this.$t('削除確認メッセージ'),
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: 'btn-light',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: 'btn-danger',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        try {
          let url = ''
          switch (state) {
            case 0:
              url =
                'partner'
              break
            case 1:
              url =
                'partner'
              break
            default:
              url =
                'partner'
              break
          }
          await this.$axios.put(
            `${this.$appConfig.CommonApiUrl}/${url}`,
            { id: item.id, isDelete: true },
            {
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
            }
          )
          this.$swal.close()
          this.$toasted.success('データ削除完了メッセージ')
          if (state === 0) window.location.href = process.env.NODE_ENV !== 'development' ? '/base/product/index.html' : '/product/index.html'
        } catch (err) {
          // this.$toasted.show(err)
          this.$toasted.show('データ削除エラーメッセージ')
        }
      }
    },
    // 標準工程の原価合計の数を代入する処理
    addTotalCost(total) {
      this.totalCost = total
    },
  },
  computed: {
    // 「材料を手配する」のチェックをできるかどうかのチェック
    isArrangeMaterial() {
      if (this.material.id) {
        return true
      } else {
        return false
      }
    },
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
}
</script>

<style lang="scss" scoped>
  .detail-content{
    tr{
      width: 150px;
    }
    td{
      width:300px;
    }
  }
</style>
